import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Colors from "styles/colors";
import { WHITE_COLOR_NAME } from "styles/color-consts";
import { MD, XS } from "constants/sizes";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import { productBannerProps } from "constants/products.js";
import { StyledUseCaseProductBanner } from "./use-case-product-banner.scss";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
const UseCaseProductBanner = (props)=>{
    var _productBannerProps_productType, _productBannerProps_productType1, _productBannerProps_productType2;
    const { theme, productType, title, body, buttonText } = props;
    const Icon = productBannerProps === null || productBannerProps === void 0 ? void 0 : (_productBannerProps_productType = productBannerProps[productType]) === null || _productBannerProps_productType === void 0 ? void 0 : _productBannerProps_productType.icon;
    return /*#__PURE__*/ _jsxs(StyledUseCaseProductBanner, {
        className: "use-case-product-banner",
        style: {
            background: Colors[theme] || Colors[WHITE_COLOR_NAME]
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "use-case-product-banner-logo-and-text-wrapper",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "use-case-product-banner-logo",
                        children: Icon && /*#__PURE__*/ _jsx(Icon, {})
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "use-case-product-banner-text",
                        children: /*#__PURE__*/ _jsx(FullParagraph, {
                            title: title,
                            body: body,
                            topic: {},
                            titleSize: XS,
                            textSize: MD,
                            mobileTextAlign: "center"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "use-case-product-banner-button",
                children: /*#__PURE__*/ _jsx(RegularButton, {
                    buttonText: buttonText,
                    color: productBannerProps === null || productBannerProps === void 0 ? void 0 : (_productBannerProps_productType1 = productBannerProps[productType]) === null || _productBannerProps_productType1 === void 0 ? void 0 : _productBannerProps_productType1.buttonColor,
                    textColor: "revert",
                    outline: true,
                    url: productBannerProps === null || productBannerProps === void 0 ? void 0 : (_productBannerProps_productType2 = productBannerProps[productType]) === null || _productBannerProps_productType2 === void 0 ? void 0 : _productBannerProps_productType2.url,
                    isOpenLinkInNewTab: true
                })
            })
        ]
    });
};
export default UseCaseProductBanner;
